import {GLInstancedObject} from "./GLInstancedObject";
import {GLModel} from "./GLModel";
import {Camera} from "./Camera";
import {Matrix} from "./Matrix";
import {Polygon} from "./Polygon";

export class GPUTube {
    instanceToPos:Array<number>;
    instanceFromPos:Array<number>;
    //リングバッファ用の措置
    prevPosArray:Array<number>;
    prevIdArray:Array<number>;
    toPosBuffer;
    fromPosBuffer;
    tubeDiv:number;
    tubeCount:number;
    instanceCount:number;
    shader:WebGLProgram;
    model:GLModel;
    uniforms:Array<{name:string,val:any}>;
    constructor(shader:WebGLProgram,model:GLModel,gl:WebGLRenderingContext,tubeDiv:number,tubeCount:number) {
        this.tubeDiv = tubeDiv;
        this.tubeCount = tubeCount;
        this.instanceCount = tubeDiv * tubeCount;
        this.instanceToPos = new Array<number>();
        this.instanceFromPos = new Array<number>();
        this.prevPosArray = new Array<number>();
        this.prevIdArray = new Array<number>();
        this.shader = shader;
        this.model = model;
        this.uniforms = [];
        for(let i = 0; i < this.instanceCount; i++){
            this.instanceToPos.push(0,0,0);

            this.instanceFromPos.push(0,0,0);
        }
        for(let i = 0; i < this.tubeCount; i++){
            this.prevPosArray.push(0,0,0);
            this.prevIdArray.push(0);
        }

        this.toPosBuffer = Polygon.CreateVBO(this.instanceToPos,gl);
        this.fromPosBuffer = Polygon.CreateVBO(this.instanceFromPos,gl);

    }

    AddPosition(pos:Array<number>,tubeIndex:number){

        var indexInArray = this.prevIdArray[tubeIndex];
        var index = indexInArray + tubeIndex * this.tubeDiv;

        this.instanceFromPos[index * 3] = this.prevPosArray[tubeIndex*3];
        this.instanceFromPos[index * 3+1] = this.prevPosArray[tubeIndex*3+1];
        this.instanceFromPos[index * 3+2] = this.prevPosArray[tubeIndex*3+2];

        this.instanceToPos[index * 3] = pos[0];
        this.instanceToPos[index * 3+1] = pos[1];
        this.instanceToPos[index * 3+2] = pos[2];

        this.prevPosArray[tubeIndex*3] = pos[0];
        this.prevPosArray[tubeIndex*3+1] = pos[1];
        this.prevPosArray[tubeIndex*3+2] = pos[2];

        this.prevIdArray[tubeIndex] = (this.prevIdArray[tubeIndex] + 1)%this.tubeDiv;
    }

    UpdateBuffer(gl:WebGLRenderingContext){
        gl.bindBuffer(gl.ARRAY_BUFFER,this.toPosBuffer);
        gl.bufferSubData(gl.ARRAY_BUFFER,0,new Float32Array(this.instanceToPos));
        gl.bindBuffer(gl.ARRAY_BUFFER,null);
        gl.bindBuffer(gl.ARRAY_BUFFER,this.fromPosBuffer);
        gl.bufferSubData(gl.ARRAY_BUFFER,0,new Float32Array(this.instanceFromPos));
        gl.bindBuffer(gl.ARRAY_BUFFER,null);
    }

    Draw = (camera:Camera,gl:WebGLRenderingContext,ext:ANGLE_instanced_arrays) => {
        const M = Matrix.identity(Matrix.create());
        const V = camera.V;
        const P = camera.P;
        gl.useProgram(this.shader);

        const positionAttLocation = gl.getAttribLocation(this.shader, 'position');
        gl.bindBuffer(gl.ARRAY_BUFFER, this.model.vbo);
        gl.enableVertexAttribArray(positionAttLocation);
        gl.vertexAttribPointer(positionAttLocation, 3, gl.FLOAT, false, 0, 0);
        ext.vertexAttribDivisorANGLE(positionAttLocation, 0);

        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.model.ibo);
        let MVPUniLocation = gl.getUniformLocation(this.shader, 'mvpMatrix');
        gl.uniformMatrix4fv(MVPUniLocation, false, Matrix.GenerateMVP(M,V,P));

        for(let i = 0; i < this.uniforms.length;i++){
            let uniLocation = gl.getUniformLocation(this.shader, this.uniforms[i].name);
            gl.uniform3fv(uniLocation, new Float32Array(this.uniforms[i].val));
        }


        const toPosAttLocation = gl.getAttribLocation(this.shader, 'toPos');
        gl.bindBuffer(gl.ARRAY_BUFFER, this.toPosBuffer);
        gl.enableVertexAttribArray(toPosAttLocation);
        gl.vertexAttribPointer(toPosAttLocation, 3, gl.FLOAT, false, 0, 0);
        ext.vertexAttribDivisorANGLE(toPosAttLocation, 1);

        const fromPosAttLocation = gl.getAttribLocation(this.shader, 'fromPos');
        gl.bindBuffer(gl.ARRAY_BUFFER, this.fromPosBuffer);
        gl.enableVertexAttribArray(fromPosAttLocation);
        gl.vertexAttribPointer(fromPosAttLocation, 3, gl.FLOAT, false, 0, 0);
        ext.vertexAttribDivisorANGLE(fromPosAttLocation, 1);

        gl.drawElements(gl.TRIANGLES, this.model.indexCount,gl.UNSIGNED_SHORT, 0);
        ext.drawElementsInstancedANGLE(gl.TRIANGLES, this.model.indexCount, gl.UNSIGNED_SHORT, 0, this.instanceCount);

    }


}